<template>
  <!--  卡券详情-->
  <div class="couponDetail">
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">卡券详情</span>
        <Reback class="row-one-fr" @click.native="reback"></Reback>
      </el-row>
      <section class="xDetail">
        <p class="xDetail-subtit-">卡券名称</p>
        <p class="xDetail-title margin-t10">{{message.sname}}</p>
        <hr class="xDetail-hr">
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>有效期：</span><span>{{message.startdate}} 至 {{message.enddate}}</span></li>
        </ul>
        <hr class="xDetail-hr">
        <p class="xDetail-instruction">
          <strong>使用说明</strong><br>
          1、购买基金时可选用兑换的基金立减券，扣除相应的这回复金额<br>
          2、单笔交易可使用多张，若交易失败，会自动退回，可再次使用<br>
          3、限其有效期内使用，过期无效<br>
          4、立减券无法转赠他人，仅限本账号使用<br>
        </p>
        <div class="xDetail-footer">
          <el-button type="normal" @click="useNowClick">立即使用</el-button>
          <el-button type="normal" class="fr" @click="continueClick">继续兑换</el-button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  name: "couponDetail",
  data () {
    return {
      message: '',
      memberFlag: false,
    }
  },
  created () {
    this.message = this.$route.params.message
  },
  mounted () {
    this.getMember()
  },
  methods: {
    reback () {
      this.$router.push({
        name: 'coupon'
      })
    },
    useNowClick () {
      this.$router.push({
        name: 'publicPurchaseLists',
        params: {
          value: 'couponDetail',
          message: this.$route.params.message
        },
      })
    },
    continueClick () {
      if (this.message.sname.indexOf('立减') != -1 && !this.memberFlag) {//立减券
        this.$message.warning('您还不是会员，此优惠券仅限会员兑换')
      } else {
        this.$router.push({
          name: 'couponExchange',
          params: {
            integral: this.message.idcoupons,
            pathName: 'coupon'
          }
        })
      }
    },
    // 会员
    getMember () {
      this.$http.post(this.$apiPath.checkContract, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.data[0]) {
          const memberInfo = res.data.data[0]
          if (memberInfo.IsMember == "true") {//会员
            this.memberFlag = true
          }
        }
      }).catch(err => { })
    },
  },
}
</script>

<style scoped lang="less">
</style>
